module.exports = __webpack_public_path__ + "static/media/etiquette-FR-kit-com.97c6289a.png";